var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.3009 9.17526H10.5014C7.61854 9.17526 5.28149 11.5123 5.28149 14.3952V45.7148C5.28149 48.5977 7.61854 50.9347 10.5014 50.9347H45.3009C48.1838 50.9347 50.5209 48.5977 50.5209 45.7148V14.3952C50.5209 11.5123 48.1838 9.17526 45.3009 9.17526Z",
    stroke: "#4E5866",
    strokeWidth: 3.47995,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.2511 28.3152C33.6925 28.3152 34.861 27.1467 34.861 25.7052C34.861 24.2638 33.6925 23.0953 32.2511 23.0953C30.8096 23.0953 29.6411 24.2638 29.6411 25.7052C29.6411 27.1467 30.8096 28.3152 32.2511 28.3152Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.951 28.3152C42.3925 28.3152 43.561 27.1467 43.561 25.7052C43.561 24.2638 42.3925 23.0953 40.951 23.0953C39.5096 23.0953 38.3411 24.2638 38.3411 25.7052C38.3411 27.1467 39.5096 28.3152 40.951 28.3152Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.2511 37.0154C33.6925 37.0154 34.861 35.8469 34.861 34.4055C34.861 32.964 33.6925 31.7955 32.2511 31.7955C30.8096 31.7955 29.6411 32.964 29.6411 34.4055C29.6411 35.8469 30.8096 37.0154 32.2511 37.0154Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.951 37.0154C42.3925 37.0154 43.561 35.8469 43.561 34.4055C43.561 32.964 42.3925 31.7955 40.951 31.7955C39.5096 31.7955 38.3411 32.964 38.3411 34.4055C38.3411 35.8469 39.5096 37.0154 40.951 37.0154Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.8514 37.0154C16.2929 37.0154 17.4614 35.8469 17.4614 34.4055C17.4614 32.964 16.2929 31.7955 14.8514 31.7955C13.41 31.7955 12.2415 32.964 12.2415 34.4055C12.2415 35.8469 13.41 37.0154 14.8514 37.0154Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.5514 37.0154C24.9928 37.0154 26.1613 35.8469 26.1613 34.4055C26.1613 32.964 24.9928 31.7955 23.5514 31.7955C22.1099 31.7955 20.9414 32.964 20.9414 34.4055C20.9414 35.8469 22.1099 37.0154 23.5514 37.0154Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.8514 45.7147C16.2929 45.7147 17.4614 44.5462 17.4614 43.1047C17.4614 41.6633 16.2929 40.4948 14.8514 40.4948C13.41 40.4948 12.2415 41.6633 12.2415 43.1047C12.2415 44.5462 13.41 45.7147 14.8514 45.7147Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M23.5514 45.7147C24.9928 45.7147 26.1613 44.5462 26.1613 43.1047C26.1613 41.6633 24.9928 40.4948 23.5514 40.4948C22.1099 40.4948 20.9414 41.6633 20.9414 43.1047C20.9414 44.5462 22.1099 45.7147 23.5514 45.7147Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M32.2511 45.7147C33.6925 45.7147 34.861 44.5462 34.861 43.1047C34.861 41.6633 33.6925 40.4948 32.2511 40.4948C30.8096 40.4948 29.6411 41.6633 29.6411 43.1047C29.6411 44.5462 30.8096 45.7147 32.2511 45.7147Z",
    fill: "#4E5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.9814 5.6955V9.17545M41.8211 5.6955V9.17545",
    stroke: "#4E5866",
    strokeWidth: 3.47995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M50.5209 17.8755H5.28149",
    stroke: "#4E5866",
    strokeWidth: 3.47995,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutline);
export default __webpack_public_path__ + "static/media/calendar-outline.8e33f9171645bc1198cd73790c579677.svg";
export { ForwardRef as ReactComponent };